module.exports = __webpack_public_path__ + "static/media/MHRM09N1025.78ad37e8.svg";